/**
 * JSON with object keys sorted at every level, so equal content always hashes the same. Arrays keep their
 * order (it is meaningful: option order, stage order).
 */
export function canonicalJson(value) {
    if (value === null || typeof value !== 'object') {
        if (typeof value === 'number' && !Number.isFinite(value))
            throw new Error('non-finite number');
        return JSON.stringify(value) ?? 'null';
    }
    if (Array.isArray(value))
        return `[${value.map(canonicalJson).join(',')}]`;
    const entries = Object.entries(value)
        .filter(([, v]) => v !== undefined)
        .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${canonicalJson(v)}`).join(',')}}`;
}
/**
 * Names people type that end up in emails and other people's screens: no control characters (line breaks
 * that could start a new email header or line), and no web addresses, so an invitation can't carry a link
 * someone else chose (task 59).
 */
// Control characters are exactly what this refuses.
// eslint-disable-next-line no-control-regex
const CONTROL = /[\u0000-\u001f\u007f-\u009f\u2028\u2029]/;
export const plainName = (s) => !CONTROL.test(s) && !/https?:|www\.|:\/\//i.test(s);
export const PLAIN_NAME_MESSAGE = 'Use a plain name: no line breaks or web addresses';
//# sourceMappingURL=json.js.map